import React from 'react';
import { NavLink } from "react-router";
import Logo from "../images/logo-dark.jpeg"

export default function footer() {
	return (
		<>
			<footer>
				<div className="footup">
					<img src={Logo} className="footlogo" alt='' />
					<div className="fuptxt">
						<h1>Byokeh Studio</h1>
						<p>-Let's Work Together</p>
					</div>
				</div>
				<div className="footmid">
					<dev className="footerl">
						<ul>
							<li><a href="https://www.instagram.com/byokeh_studio/" target="_blank" rel="noopener noreferrer">
								Instagram
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-right" viewBox="0 0 16 16">
									<path fill-rule="evenodd" d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0z" />
								</svg>
							</a></li>
							<li><a href="https://www.youtube.com/@byokeh_studio" target="_blank" rel="noopener noreferrer">
								Youtube
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-right" viewBox="0 0 16 16">
									<path fill-rule="evenodd" d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0z" />
								</svg>
							</a></li>
							<li>
								<NavLink to="/about">
									About
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-right" viewBox="0 0 16 16">
										<path fill-rule="evenodd" d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0z" />
									</svg>
								</NavLink>
							</li>
							<li>
								<NavLink to="/projects">
									Projects
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-right" viewBox="0 0 16 16">
										<path fill-rule="evenodd" d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0z" />
									</svg>
								</NavLink>
							</li>
							<li>
								<NavLink to="/contact">
									Contact
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-right" viewBox="0 0 16 16">
										<path fill-rule="evenodd" d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0z" />
									</svg>
								</NavLink>
							</li>
						</ul>
					</dev>
					<div className="footerr">
						<p>I’m <strong>currently available</strong> for new projects.</p>
						<p>If you’re looking for a photographer, videographer, video editor, or developer.</p>
						<p>I’d love to collaborate and bring your ideas to life!</p>
					</div>
				</div>
				<div className="footdown">
					<h3>© 2025 Byokeh Studio. All rights reserved. <span> | </span>Developed by Byokeh Studio</h3>
				</div>
			</footer>
		</>
	)
}
